import { z } from 'zod';

import { CmsUrl } from '../models';
import { BasePType } from './base';
import { PrimaryFooterLink } from './primary-footer-link';

export const BorderStyling = z.object({
  borderRadiusPx: z.string().nullable(),
  borderThicknessPx: z.number(),
  bottomBorder: z.boolean(),
  leftBorder: z.boolean(),
  rightBorder: z.boolean(),
  topBorder: z.boolean(),
});

export type BorderStyling = z.infer<typeof BorderStyling>;

export const PrimaryFooterColumn = BasePType.extend({
  type: z.enum(['primaryFooterColumn']),
  border: BorderStyling,
  nestedContent: z.array(PrimaryFooterLink),
  url: CmsUrl,
});

export type PrimaryFooterColumn = z.infer<typeof PrimaryFooterColumn>;
